import axios from "axios";

require('./../../app_bootstrap');
import VueI18n from 'vue-i18n'
import deCH from '../../../../lang/manufaktur/amag/de-ch.json'
import frCH from '../../../../lang/manufaktur/amag/fr-ch.json'
import itCH from '../../../../lang/manufaktur/amag/it-ch.json'

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {
}

window.flatPickr = require('vue-flatpickr-component');
import 'flatpickr/dist/flatpickr.css';
window.flatPickrGerman = require('flatpickr/dist/l10n/de');
flatPickrGerman.firstDayOfWeek = 1;

window.Popper = require('popper.js').default;

window.Vue = require('vue');

import {flatten} from 'q-flat';
window.flatten = flatten;

Vue.prototype.$http = axios;

import PNotify from '../../../../../node_modules/pnotify/dist/es/PNotify.js';
import PNotifyButtons from '../../../../../node_modules/pnotify/dist/es/PNotifyButtons.js';

PNotify.defaults.styling = 'bootstrap4';
PNotify.defaults.icons = 'fontawesome5';

window.PNotify = PNotify

Vue.prototype.$notify = PNotify

const pvPublicKey = document.head.querySelector('meta[name="pv-public-key"]');
if(pvPublicKey){
    Vue.prototype.$pvPublicKey = pvPublicKey.content
}



window.numeral = require('numeral');
numeral.register('locale', 'de', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 't',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: '€'
    }
});
numeral.locale('de');

require('./../appConfig');
require('./../coreComponents');
require('./../packageComponents');
require('./../src');
require('./../helpers');
require('./../gtm-tracking');
require('./../ComponentCollections/cdb_collection');

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

Vue.component('VueSlider', VueSlider);

$(document).ready(function () {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
});
const messages = {
    "de-ch": deCH,
    "fr-ch": frCH,
    "it-ch": itCH
}
const lang = document.documentElement.lang
const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: "de-ch",
    messages
})

let appContainer = document.getElementById('paymentMethod');

if(appContainer !== null){
    new Vue({
        el: '#paymentMethod',
        i18n
    });
}
